import { createSelector } from 'reselect';

export const offerSelectors = state => state.offer;

export const allCoveragesSelector = createSelector(offerSelectors, item => item?.data?.produtos[0]?.coberturas);

export const allAssistanceSelector = createSelector(offerSelectors, item => item?.data?.produtos[0]?.assistencias);
